import { setCookie } from '@cian/utils/lib/browser/cookie';

export const REGISTRATION_TRIGGER_COOKIE = 'serp_registration_trigger_popup';

export function setRegistrationTriggerCookie() {
  const cookieConfig = {
    secure: false,
    expires: 3600 * 24 * 5,
  };

  setCookie(REGISTRATION_TRIGGER_COOKIE, '1', cookieConfig);
}
